import React, { useState } from 'react';
import { useGetAdminCompetitionItemPrizePlacesQuery } from 'entities/competitions-b2b';
import { useNavigate } from 'react-router-dom';
import { DataTableBackendPagination } from 'shared/ui/Table';
import { SelectFilter } from 'shared/ui/Filter/ui/SelectFilter'; // Corrected path
import { debounce } from 'lodash';
import { fields } from './model';

const statusOptions = [
  { label: '2', value: 'Доступен для выбора' },
  { label: '3', value: 'Выбран' },
  { label: '4', value: 'Выдано' },
  { label: '5', value: 'Выдача приостановлена' },
  { label: '6', value: 'Отправлено' },
  { label: '7', value: 'Отклонено' },
];

const CompetitionsPrizePlacesWidget = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState<number | undefined>(undefined);
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 5,
  });

  const { data: prizePlaces } = useGetAdminCompetitionItemPrizePlacesQuery({
    page: pagination.page + 1,
    size: pagination.rowsPerPage,
    search,
    status,
  });

  const handleUserSelect = (id: number | string) => {
    navigate(`/promo/prize_places/${id}`);
  };

  if (!prizePlaces) return null;

  const transformedItems = prizePlaces.items.map((item) => ({
    ...item,
    id: Number(item.id),
    competition: item.competition.name,
    place: item.place,
    dateChosen: item.time_award_selection ? new Date(item.time_award_selection).toLocaleDateString() : '---',
    dateHasGot: item.time_award_receiving ? new Date(item.time_award_receiving).toLocaleDateString() : '---',
    awardChosen: item.award_chosen?.prize?.name
      ? item.award_chosen?.prize?.name
      : item.award_chosen?.coins
      ? `${item.award_chosen?.coins} монет`
      : '---',
  })) as any[];

  const onSearch = debounce((searchVal: string) => {
    setPagination((prev) => ({ ...prev, page: 0 }));
    setSearch(searchVal);
  }, 300);

  const handleStatusChange = (selectedValue: string | number[]) => {
    setPagination((prev) => ({ ...prev, page: 0 }));
    let newStatus: number | undefined;
    if (typeof selectedValue === 'string' && selectedValue !== '') {
      const parsed = parseInt(selectedValue, 10);
      if (!isNaN(parsed)) {
        newStatus = parsed;
      }
    }
    setStatus(newStatus);
  };

  return (
    <>
      <div style={{ marginBottom: '1rem', maxWidth: '250px', minWidth: '250px' }}>
        <SelectFilter
          label="Статус"
          data={statusOptions}
          onChange={handleStatusChange}
          style={{ width: '100%' }}
        />
      </div>
      <DataTableBackendPagination
        columnConfig={fields as any}
        title="Таблица призовых мест"
        total={Number(prizePlaces.total)}
        pagination={pagination}
        setPagination={setPagination}
        search
        searchPlaceholder="Поиск по телефону и ФИО"
        onSearch={onSearch}
        onRowClick={handleUserSelect}
        data={transformedItems}
      />
    </>
  );
};

export { CompetitionsPrizePlacesWidget };
